import ListActions from "modules/list/actions";
import api from "services/api";
import store from "services/store";
import { getCluster } from "state/cluster/selectors/details";
import { JobSchema } from "utils/schemas";

export const JOBS_MODULE = "jobs";

export const jobsListingActions = new ListActions({
  async fetchData({ filterBy = [] } = {}) {
    const cluster = getCluster(store.getState());

    const data = await api.post(
      `v1/dashboard/spectroclusters/${cluster.metadata.uid}/workloads/job`,
      {
        filter: {
          namespaces: filterBy,
        },
      }
    );

    return {
      items: (data?.jobs || []).sort((job1, job2) =>
        job1.metadata.namespace > job2.metadata.namespace ? 1 : -1
      ),
    };
  },
  initialQuery: () => ({
    filterBy: [],
  }),
  schema: [JobSchema],
});
